import { formatDate } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateString',
  standalone: true,
})
export class DateStringPipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) public locale: string) {}

  transform({ booking, shortMonth }): string {
    const { ReturnDate, DepartureDate } = booking;
    const monthFormat = shortMonth ? 'MMM' : 'MMMM';

    if (this.areDatesEqual(DepartureDate, ReturnDate)) {
      return formatDate(ReturnDate, `dd ${monthFormat} yyyy`, this.locale);
    }

    if (this.haveDifferentYears(DepartureDate, ReturnDate)) {
      return `${formatDate(DepartureDate, `dd ${monthFormat} yyyy`, this.locale)} - ${formatDate(
        ReturnDate,
        `dd ${monthFormat} yyyy`,
        this.locale,
      )}`;
    }

    if (this.haveDifferentMonths(DepartureDate, ReturnDate)) {
      return `${formatDate(DepartureDate, `dd ${monthFormat}`, this.locale)} - ${formatDate(
        ReturnDate,
        `dd ${monthFormat} yyyy`,
        this.locale,
      )}`;
    }

    return `${formatDate(DepartureDate, `dd`, this.locale)} - ${formatDate(
      ReturnDate,
      `dd ${monthFormat} yyyy`,
      this.locale,
    )}`;
  }

  areDatesEqual(DepartureDate: Date, ReturnDate: Date): boolean {
    return (
      this.getDay(DepartureDate) === this.getDay(ReturnDate) &&
      this.getMonth(DepartureDate) === this.getMonth(ReturnDate) &&
      this.getYear(DepartureDate) === this.getYear(ReturnDate)
    );
  }

  haveDifferentDays(DepartureDate: Date, ReturnDate: Date): boolean {
    return this.getDay(DepartureDate) !== this.getDay(ReturnDate);
  }

  haveDifferentMonths(DepartureDate: Date, ReturnDate: Date): boolean {
    return this.getMonth(DepartureDate) !== this.getMonth(ReturnDate);
  }

  haveDifferentYears(DepartureDate: Date, ReturnDate: Date): boolean {
    return this.getYear(DepartureDate) !== this.getYear(ReturnDate);
  }

  getYear(date: Date): number {
    return new Date(date).getFullYear();
  }

  getMonth(date: Date): number {
    return new Date(date).getMonth();
  }

  getDay(date: Date): number {
    return new Date(date).getDate();
  }
}
